export default __webpack_public_path__ + "6ee7b03ebf0090b0359ec233c3b9257b.png";